var map = {
	"./bank-v2/route.js": "0b97",
	"./class-operation-v2/route.js": "0fd6",
	"./currency/route.js": "536e",
	"./daily-closeout-report/components/index.js": "54a6",
	"./daily-closeout-report/config/columns.js": "5078",
	"./daily-closeout-report/config/index.js": "ad08",
	"./daily-closeout-report/route.js": "a0b2",
	"./exchange-rate/route.js": "ba52",
	"./invoice-ajustment/components/index.js": "afd4",
	"./invoice-ajustment/route.js": "886b",
	"./khqr-payment/route.js": "4492",
	"./monthly-semester-mapping/router.js": "2f7a",
	"./payment-statistic/route.js": "b08b",
	"./pre-invoice-v2/route.js": "6748",
	"./router.js": "37f3",
	"./score-copy/router.js": "b472",
	"./student-statistic/route.js": "131e",
	"./student-transfer-module/components/index.js": "3d32",
	"./student-transfer-module/router.js": "313a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "52f3";